import "core-js/modules/es.array.push.js";
import { ref, unref, watch } from 'vue';
import { useRouter } from 'vue-router';
import { VxeMenu } from 'vxe-pc-ui';
export default {
  name: 'XMenu',
  components: {
    VxeMenu
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    expandAll: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  emits: ['item-click', 'collapsed-change', 'update:collapsed'],
  setup(props, {
    emit
  }) {
    const router = useRouter();
    const modelValue = ref();
    const menuCollapsed = ref(props.collapsed);
    watch(() => props.collapsed, val => {
      menuCollapsed.value = val;
    }, {
      immediate: true
    });
    watch(() => menuCollapsed, val => {
      const newVal = unref(val);
      if (newVal !== menuCollapsed.value) {
        emit('collapsed-change', newVal);
      }
      emit('update:collapsed', newVal);
    }, {
      immediate: false
    });
    const handleItemClick = ({
      menu,
      $event
    }) => {
      modelValue.value = menu;
      emit('item-click', menu, $event);
      const {
        action,
        target,
        params = {},
        query = {}
      } = menu || {};
      if (!action) return;
      if (typeof action === 'string') {
        if (target) {
          const link = router.resolve({
            path: action
          });
          window.open(link.href, target);
        } else {
          router.push({
            path: action,
            query,
            params
          }).catch(e => {
            console.error(e);
          });
        }
      } else if (typeof action === 'object') {
        router.push(action);
      } else if (typeof action === 'function') {
        action();
      }
    };
    return {
      handleItemClick,
      menuCollapsed,
      modelValue
    };
  }
};